import {CLIENT_URL} from "../constants/endpoints";

export default function uiCustomization() {
    var button, styleFrame;

    function getCssVars() {

        function isSameDomain(styleSheet) {
            if ((!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
                || (styleSheet.href && styleSheet.href.endsWith("variables.css"))) {
                return true;
            }
            return false;
        }

        function isStyleRule(rule) {
            return rule.type === 1;
        }

        const cssVars = [...document.styleSheets].filter(isSameDomain).reduce(
            (finalArr, sheet) =>
                finalArr.concat(
                    [...sheet.cssRules].filter(isStyleRule).reduce((propValArr, rule) => {
                        const props = [...rule.style]
                            .map((propName) => [
                                propName.trim(),
                                rule.style.getPropertyValue(propName).trim()
                            ])
                            .filter(([propName]) => propName.indexOf("--TX") === 0);

                        return [...propValArr, ...props];
                    }, [])
                ),
            []
        );

        let result = {};
        for (let i = 0; i < cssVars.length; i++) {
            result[cssVars[i][0]] = cssVars[i][1];
        }
        return result;
    }

    function cssVarsToSchema(cssVars) {
        var schema = {"title": "EDIT", "type": "object", "properties": {}};

        for (let key in cssVars) {
            if (cssVars.hasOwnProperty(key)) {
                let value = cssVars[key];
                let property = {"type": "string", "default": value};
                property.title = key.substring(2);
                if (value.indexOf("#") === 0) {
                    property.format = "color"
                }
                schema.properties[key] = property;
            }
        }

        return schema;
    }

    function setCssVars(cssVars) {
        var r = document.querySelector(':root');
        for (let key in cssVars) {
            if (cssVars.hasOwnProperty(key)) {
                r.style.setProperty(key, cssVars[key]);
            }
        }
    }

    window.addEventListener("message", function (message) {
        if (typeof message.data !== "object" || (message.data._inggTarget !== "setCssVars" && message.data._inggTarget !== "closeCssVars")) {
            return;
        }
        if (message.data._inggTarget === "setCssVars") {
            setCssVars(message.data.cssVars);
        }
        if (message.data._inggTarget === "closeCssVars") {
            styleFrame.style.display = "none";
            button.style.display = "";
        }
    });

    var styleUrl = CLIENT_URL + '/uiCustomization/bootstrap.min.css';
    var jsonEditorUrl = CLIENT_URL + '/uiCustomization/jsoneditor.min.js';
    var srcdoc = "<!doctype html><html><head><link rel='stylesheet' href='" + `${styleUrl}` + "'> <script src='" + `${jsonEditorUrl}` + "'></script></head><body><div id='editor'></div><button id='close-button' style='position: fixed;bottom: 0;margin-bottom: 5px;right:0;'>Close</button><script>var editor = new JSONEditor(document.getElementById('editor'),{theme: 'bootstrap3','iconlib': 'bootstrap3', schema:" + JSON.stringify(cssVarsToSchema(getCssVars())) + "}); function updateCSSVars(){window.parent.postMessage({_inggTarget:'setCssVars',cssVars:editor.getValue()},'*')} function close(){window.parent.postMessage({_inggTarget:'closeCssVars'},'*')} editor.on('change',updateCSSVars); document.querySelector('#close-button').onclick=close;</script></body></html>";
    styleFrame = document.createElement("iframe");
    styleFrame.setAttribute("srcdoc", srcdoc);
    styleFrame.style.width = "20%";
    styleFrame.style.height = "100%";
    styleFrame.style.zIndex = "1000";
    styleFrame.style.border = "1px solid red";
    styleFrame.style.position = "absolute";
    styleFrame.style.top = "0px";
    styleFrame.style.left = "0px";
    styleFrame.style.backgroundColor = "#FFFFFF";
    styleFrame.style.maxWidth = "450px";
    styleFrame.style.display = "none";
    document.body.appendChild(styleFrame);
    button = document.createElement("button");
    button.innerText = "Edit Style";
    button.style.position = "absolute";
    button.style.top = "10px";
    button.style.left = "10px";
    button.style.zIndex = "1000";
    button.onclick = function () {
        styleFrame.style.display = "";
        button.style.display = "none";
    };
    document.body.appendChild(button);
};


// WEBPACK FOOTER //
// ./src/helpers/uiCustomization.js